import React, { useMemo } from 'react';
import { useAccDocuments } from '../../accounting/documents/useData';
import { StatusBreakdown, type StatusBreakdownRow } from './shared';

const FinancePeriodActivity: React.FC<{ embedded?: boolean; settings?: Record<string, unknown> }> = ({
  embedded,
}) => {
  const { data, isLoading } = useAccDocuments(undefined, 1, 200);

  const rows: StatusBreakdownRow[] = useMemo(() => {
    const totals = { DRAFT: 0, TEMP: 0, SAVED: 0 };
    for (const doc of data ?? []) {
      if (doc.status in totals) totals[doc.status as keyof typeof totals] += 1;
    }
    return [
      { key: 'draft', label: 'Draft', value: totals.DRAFT, color: 'bg-slate-400' },
      { key: 'temp', label: 'Temp', value: totals.TEMP, color: 'bg-amber-500' },
      { key: 'saved', label: 'Saved', value: totals.SAVED, color: 'bg-emerald-500' },
    ];
  }, [data]);

  return (
    <StatusBreakdown
      title="Finance · Journal status"
      rows={rows}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/accounting/journals"
      emptyMessage="No journals"
    />
  );
};

export default FinancePeriodActivity;
